
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance/learn",
      function () {
        return require("private-next-pages/finance/learn.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance/learn"])
      });
    }
  